import CustomSelect from "../common/CustomSelect";
import InputField from "../common-managment/InputField";
import save from "../../assets/icons/save.svg";
import { RiCloseLargeFill } from "react-icons/ri";

export default function EditAddData({
  data,
  setData,
  handleSave,
  setAddRowForm,
}) {
  // ✅ Generic change handler for text/date
  const handleChange = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <tr className="text-[#242424] divide-x divide-[#323649] border-t border-[#323649] bg-[#D7EFFF]">
      <td className="px-5 py-[9px]"></td>
      <td className="px-5 py-[9px]"></td>

      {/*  Name */}
      <td className="px-[5px] py-1">
        <InputField
          placeholder="프로젝트 이름"
          value={data.name}
          onChange={(e) => handleChange("name", e.target.value)}
        />
      </td>

      {/* authority */}

      <td className="px-5 py-1.5">
        <CustomSelect
          label="권한"
          value={data?.authority}
          options={["Manager", "USER"]}
          onSelect={(val) => handleChange("authority", val)}
        />
      </td>
      {/*  memo*/}
      <td className="px-[5px] py-1">
        <InputField
          placeholder="메모"
          value={data?.memo}
          onChange={(e) => handleChange("memo", e.target.value)}
        />
      </td>

      {/* Actions */}
      <td className="px-5 py-[9px]">
        <div className="flex items-center gap-7 justify-center w-[80px] mx-auto">
          <button
            onClick={() => {
              handleSave();
              setAddRowForm(false);
            }}
          >
            <img src={save} alt="save" className="w-4 h-4" />
          </button>
          <button onClick={() => setAddRowForm(false)}>
            <RiCloseLargeFill size={14} color="#242424" />
          </button>
        </div>
      </td>
    </tr>
  );
}
